'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _enum = require('@vezeeta/enterprise-utils/lib/enum');

var _payment = require('../actions/payment');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var initialState = {
  paymentDetailsState: undefined,
  paymentDetails: {},
  cardsState: undefined,
  cards: [],
  error: undefined,
  transactionDetails: undefined,
  paymentMethods: undefined,
  paymentMethodsState: _enum.status.SHOULD_CALL_API,
  validTransactionDetails: undefined,
  validTransactionDetailsState: _enum.status.SHOULD_CALL_API,
  addPaymentTransactionDetails: undefined,
  addPaymentTransactionDetailsState: _enum.status.SHOULD_CALL_API,
  updatePaymentMethod: undefined,
  updatePaymentMethodState: _enum.status.SHOULD_CALL_API,
  setPaymentMethod: undefined,
  setPaymentMethodState: _enum.status.SHOULD_CALL_API
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];

  var type = _ref.type,
      payload = _objectWithoutProperties(_ref, ['type']);

  switch (type) {
    case _payment.PAYMENT.SET_PAYMENT_METHOD.SUBMIT:
      {
        return _extends({}, state, {
          setPaymentMethodState: _enum.status.SUBMITING
        });
      }

    case _payment.PAYMENT.SET_PAYMENT_METHOD.SUCCEEDED:
      {
        return _extends({}, state, {
          setPaymentMethod: payload.payload,
          setPaymentMethodState: _enum.status.SUCCESS
        });
      }

    case _payment.PAYMENT.SET_PAYMENT_METHOD.FAILED:
      {
        return _extends({}, state, {
          setPaymentMethod: payload.payload,
          setPaymentMethodState: _enum.status.FAIL
        });
      }

    case _payment.PAYMENT.UPDATE_PAYMENT_METHOD.SUBMIT:
      {
        return _extends({}, state, {
          updatePaymentMethodState: _enum.status.SUBMITING
        });
      }

    case _payment.PAYMENT.UPDATE_PAYMENT_METHOD.SUCCEEDED:
      {
        return _extends({}, state, {
          updatePaymentMethod: payload.payload,
          updatePaymentMethodState: _enum.status.SUCCESS
        });
      }

    case _payment.PAYMENT.UPDATE_PAYMENT_METHOD.FAILED:
      {
        return _extends({}, state, {
          updatePaymentMethod: payload.payload,
          updatePaymentMethodState: _enum.status.FAIL
        });
      }

    case _payment.PAYMENT.ADD_PAYMENT_TRANSACTION.SUBMIT:
      {
        return _extends({}, state, {
          addPaymentTransactionDetailsState: _enum.status.SUBMITING
        });
      }

    case _payment.PAYMENT.ADD_PAYMENT_TRANSACTION.SUCCEEDED:
      {
        return _extends({}, state, {
          addPaymentTransactionDetails: payload.payload,
          addPaymentTransactionDetailsState: _enum.status.SUCCESS
        });
      }

    case _payment.PAYMENT.ADD_PAYMENT_TRANSACTION.FAILED:
      {
        return _extends({}, state, {
          addPaymentTransactionDetails: payload.payload,
          addPaymentTransactionDetailsState: _enum.status.FAIL
        });
      }

    case _payment.PAYMENT.PAYMENT_METHODS.LOADING:
      {
        return _extends({}, state, {
          paymentMethodsState: _enum.status.FETCHING
        });
      }

    case _payment.PAYMENT.PAYMENT_METHODS.SUCCEEDED:
      {
        return _extends({}, state, {
          paymentMethods: payload.paymentMethods,
          paymentMethodsState: _enum.status.SUCCESS
        });
      }

    case _payment.PAYMENT.PAYMENT_METHODS.FAILED:
      {
        return _extends({}, state, {
          paymentMethodsState: _enum.status.FAIL
        });
      }

    case _payment.VALID_TRANSACTION.LOADING:
      {
        return _extends({}, state, {
          validTransactionDetails: undefined,
          validTransactionDetailsState: _enum.status.FETCHING
        });
      }

    case _payment.VALID_TRANSACTION.SUCCEEDED:
      {
        return _extends({}, state, {
          validTransactionDetails: payload.transactionDetails,
          validTransactionDetailsState: _enum.status.SUCCESS
        });
      }

    case _payment.VALID_TRANSACTION.FAILED:
      {
        return _extends({}, state, {
          validTransactionDetailsState: _enum.status.FAIL
        });
      }

    case _payment.TRANSACTION_INFO.SET:
      return _extends({}, state, { transactionDetails: payload.payload });

    case _payment.PAYMENT.GET_PAYMENT_DETAILS.LOAD:
      {
        return _extends({}, state, {
          paymentDetailsState: _payment.PAYMENT.GET_PAYMENT_DETAILS.LOAD
        });
      }

    case _payment.PAYMENT.GET_PAYMENT_DETAILS.SUCCEEDED:
      {
        return _extends({}, state, {
          paymentDetailsState: _payment.PAYMENT.GET_PAYMENT_DETAILS.SUCCEEDED,
          paymentDetails: payload.paymentDetails
        });
      }

    case _payment.PAYMENT.GET_PAYMENT_DETAILS.FAILED:
      {
        return _extends({}, state, {
          paymentDetailsState: _payment.PAYMENT.GET_PAYMENT_DETAILS.FAILED,
          error: payload.error
        });
      }

    case _payment.PAYMENT.GET_CREDIT_CARDS.LOAD:
      {
        return _extends({}, state, {
          cardsState: _payment.PAYMENT.GET_CREDIT_CARDS.LOAD
        });
      }

    case _payment.PAYMENT.GET_CREDIT_CARDS.SUCCEEDED:
      {
        return _extends({}, state, {
          cardsState: _payment.PAYMENT.GET_CREDIT_CARDS.SUCCEEDED,
          cards: payload.cards
        });
      }

    case _payment.PAYMENT.GET_CREDIT_CARDS.FAILED:
      {
        return _extends({}, state, {
          cardsState: _payment.PAYMENT.GET_CREDIT_CARDS.FAILED,
          error: payload.error
        });
      }

    default:
      {
        return state;
      }
  }
};

module.exports = exports['default'];